/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Public from 'Public';
export default {
  props: {
    goodsNum: {
      type: [Number, String]
    },
    max: [Number, String],
    min: {
      type: [Number, String],
      "default": 1
    },
    invalid: Boolean
  },
  watch: {
    num: function num(val, oldVal) {
      if (this.firstFlag || this.max == 0 || val <= 0) {
        return;
      }

      var old = oldVal;
      console.log('old:   ' + oldVal);

      if (this.max && val > this.max) {
        Public.tips({
          text: '超过范围！'
        });
        this.num = this.max;
        return;
      } else if (this.min && val < this.min) {
        Public.tips({
          text: '超过范围！'
        });
        this.num = this.min;
        return;
      }

      if (!this.firstFlag) {
        this.$emit('numChange', [val, oldVal]);
      }
    },
    goodsNum: function goodsNum(val) {
      console.log(val);
      this.firstFlag = true;
      this.num = val;
    },
    max: function max(val) {
      if (val && this.num > val) {
        this.num = val;
      }
    },
    min: function min(val) {
      if (val && this.num < val) {
        this.num = val;
      }
    }
  },
  data: function data() {
    return {
      num: '',
      done: '',
      firstFlag: false
    };
  },
  created: function created() {
    if (this.goodsNum) {
      this.num = this.goodsNum;
      this.firstFlag = true;
    }

    console.log('num:  ');
  },
  computed: {
    canMinus: function canMinus() {
      var goodsNum = this.num || this.goodsNum;
      console.log('goodsNum:' + goodsNum);

      if (goodsNum <= 1 || goodsNum > 1 && goodsNum <= this.min) {
        return false;
      } else {
        return true;
      }
    },
    canPlus: function canPlus() {
      var goodsNum = this.num || this.goodsNum;
      ;
      console.log('goodsNum:' + goodsNum);

      if (!this.max && this.max != 0) {
        return true;
      } else if (goodsNum >= this.max) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    minusNum: function minusNum() {
      var num = this.num || this.goodsNum;

      if (this.canMinus && !this.invalid) {
        this.done = 'minus';
        num--;
        this.num = num;
        this.firstFlag = false;
      }
    },
    plusNum: function plusNum() {
      var num = this.num || this.goodsNum;

      if (this.canPlus && !this.invalid) {
        this.done = 'plus';
        num++;
        this.num = num;
        this.firstFlag = false;
      }
    },
    inputChage: function inputChage() {
      if (this.invalid) {
        return;
      }

      this.firstFlag = false;
    },
    blurEvent: function blurEvent() {
      //IOS 虚拟键盘顶起内容不下
      if (Public.getSystemInfo().sysType === 1) {
        console.log('NumEdit blurEvent');
        document.body.scrollTop = 0;
      }
    }
  }
};